export const getCardNumberMaskFromBraintreeCardObject = card =>
    card.gaps
        .concat(Math.max(...card.lengths))
        .reduce(
            (lengths, current) => [
                ...lengths,
                current - lengths.reduce((a, b) => a + b, 0),
            ],
            []
        )
        .map(length => '#'.repeat(length))
        .join(' ');
